import axios from '../../../utils/request';

function GET_INDUSTRY(params) {
    return axios.get("/customer/ACustomerIndustry/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/customer/ACustomerIndustry/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/customer/ACustomerIndustry/edit",{ id:params } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/customer/ACustomerIndustry/editPost",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/customer/ACustomerIndustry/listOrder",{list_orders:params} )
}


// function CHANG_STATUS (params) {
//     return  axios.post("/admin/ARole/statusEdit",{status:params} )
// }
function DELE(params) {
    return  axios.get("/customer/ACustomerIndustry/delete",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_INDUSTRY,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    LIST_ORDER,
    DELE

};